export const styles = theme => ({
    paperWidthSm: {
        width: '80%',
        maxWidth: 'unset',
        height: '80%'
    },
    // title: {
    //     '@media screen and (min-width: 1200px) and (max-width: 1920px)': {
    //         fontSize: 34,
    //         fontWeight: 500,
    //     },
    // },
    marginCloseButton: {
        width: '2rem',
        height: '2rem'
    },
    rootDialogContent: {
        padding: '0% 3.8542%',
    },
    rootDialogActions: {
        margin: 0,
        position: 'absolute',
        top: '0%',
        right: '0%'
    }
})